import {Injectable, Inject} from '@angular/core';
import {
  RestService,
  RestYiiFilterService,
  RestYiiSort,
  RestYiiPagination,
  RestSimpleResponseParser,
  RestQueryParams
} from 'gelios-ng-admin-components';
import {HttpClient, HttpParams} from '@angular/common/http';
import {AuthorizationService} from '../../../app/authorization/authorization.service';

@Injectable()
export class ForeignKeyDataService extends RestService <any> {
  protected modelName;
  public get url(): string {
    return this.environmentApiBasepoint + this.modelName;
  }

  constructor(
    protected http: HttpClient,
    protected _filter: RestYiiFilterService,
    protected _sort: RestYiiSort,
    protected _pagination: RestYiiPagination,
    protected _parser: RestSimpleResponseParser,
    @Inject('ENVIRONMENT_VERSION') protected environmentVersion: string,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint: string,
    protected authorizationService: AuthorizationService
  ) {
    super(http, _filter, _sort, _pagination, _parser, environmentVersion, environmentApiBasepoint);
    this.expand = '';
  }
  public setFields(fields: string) {
    // if (this.modelName && this.authorizationService.getEntityAccessRightsInstant()[this.modelName]) {
    //   fields = fields ? fields
    //     .split(',')
    //     .filter(
    //       requestField => this.authorizationService.getEntityAccessRightsInstant()[this.modelName].list
    //         .findIndex(accessOkField => accessOkField === requestField) !== -1
    //     )
    //     .join(',') : fields;
    // }
    this.fields = fields;
    return this;
  }
  public setExpand(extra: string) {
    // if (this.modelName) {
    //   extra = extra ? extra
    //     .split(',')
    //     .filter(
    //       requestField => this.authorizationService.getEntityAccessRightsInstant()[this.modelName].list
    //         .findIndex(accessOkField => accessOkField === requestField) !== -1
    //     )
    //     .join(',') : extra;
    // }
    // if (extra && typeof extra === 'string' && extra.length) {
    this.expand = extra;
    // }
    return this;
  }
  public setModelName(modelName: string) {
    this.modelName = modelName;
    return this;
  }
  public setSearchModelName(searchModelName: string) {
    this._filter.searchModelName = searchModelName;
    return this;
  }
}
